import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header card-header-stretch" }
const _hoisted_3 = { class: "card-title d-flex align-items-center" }
const _hoisted_4 = { class: "svg-icon svg-icon-1 svg-icon-primary me-3 lh-0" }
const _hoisted_5 = /*#__PURE__*/_createVNode("h3", { class: "fw-bolder m-0 text-gray-800" }, "Jan 24, 2021", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("span", _hoisted_4, [
          _createVNode(_component_inline_svg, { src: "media/icons/duotone/Interface/Calendar.svg" })
        ]),
        _hoisted_5
      ])
    ])
  ]))
}